import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('allstadiums/list', { params });
  },
  async add(params: any) {
    return axios.post('allstadiums/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('allstadiums/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('allstadiums/detail', { params });
  },
  async delete(params: any) {
    return axios.post('allstadiums/delete', qs.stringify(params));
  },
  async repeat(params: any) {
    return axios.post('allstadiums/repeat', qs.stringify(params));
  }
};
